import { AccessLevel } from '#pplx/frontend/components/types/types.js';
export const ALLOWED_SPACES_THREAD_PERMISSIONS = [
    AccessLevel.OWNER_ONLY,
    AccessLevel.PRIVATE_READ,
    AccessLevel.COLLECTION_READ,
];
//# sourceMappingURL=constants.js.map